import Shuffle from 'array-shuffle';

import Config from '../config';
import Interface from '../interface';

import API from '@app/api';

export default class Predefined extends Interface {
  items = [];
  advertId = false;
  currentItem = false;

  /**
   * Binds all private methods
   * @param  {Array} items Media items
   * @param  {Number} advertId Advertisement ID
   */
  constructor(items = Config.media, advertId = false) {
    super();

    // Just a little something to shuffle our pre-configured list
    this.items = Shuffle(items);
    this.advertId = advertId;
  }

  updateAdvertId(advertId) {
    this.advertId = advertId;
  }

  get duration() {
    // How long before rotation should occur
    return Config.rotate;
  }

  get allowEmpty() {
    // It's possible that a channel has nothing configured
    // which results in a black screen.
    return true;
  }

  get rotationEnabled() {
    // Only rotate if there is at least 1 wallpaper in queue,
    // and one currently selected. The currently selected one
    // will not be in the queue so it would be 0.
    return this.items.length >= 1 && this.currentItem;
  }

  markUnavailable() {
    // By setting currentItem to false, the next
    // rotation will not re-add it to the list and
    // thus it will not be retried
    this.currentItem = false;
  }

  async getMedia() {
    if (this.advertId) {
      this.identifier = 'wallpaper_predefined_ad';
      const response = await API.Wallpaper.load(null, {
        pathExtValues: {
          advertId: this.advertId,
        },
      });
      if (response.status === 200) {
        return response.body;
      }

      return false;
    }

    // If there already was a previous one, we'll add it
    // back to the list. This is obviously only needed
    // while we are using a simple array of media items.
    if (this.currentItem) {
      this.items.push(this.currentItem);
    }

    // Fetch the next media item from the configured list
    this.currentItem = this.items.shift();
    this.identifier = 'wallpaper_predefined_channel';

    return this.currentItem;
  }
}
